import qs from "query-string";
import { combineReducers } from "redux";
import { handleActions } from "redux-actions";

import { TOAST_TYPE } from "lib/constants";

import {
    addPosition,
    showModal,
    hideModal,
    showInfoToast,
    showWarningToast,
    showErrorToast,
    hideToast,
    uiSetAsyncError,
    uiSetLoading,
    uiSetSubmitting,
    setUserAction,
    setUserLanguage,
    decrementAlert,
    incrementAlert,
    setCommentCounts,
    numberAlertChange,
    uiPauseReportAHireModal,
    uiSetIsUpdateEmploymentStatusModalClosed,
} from "./actions";

const modals = handleActions(
    {
        [showModal]: (state, { payload }) => state.concat([payload]),
        [hideModal]: (state) => state.slice(0, state.length - 1),
    },
    [],
);

const ui = handleActions(
    {
        [uiSetAsyncError]: (state, { payload }) => ({
            ...state,
            asyncError: payload,
        }),
        [uiSetLoading]: (state, { payload }) => ({
            ...state,
            loading: !!payload,
            asyncError: payload ? null : state.asyncError,
        }),
        [uiSetSubmitting]: (state, { payload }) => ({
            ...state,
            submitting: !!payload,
            asyncError: payload ? null : state.asyncError,
        }),
        // This function is used to toggle the ReportAHireModal component that exists
        // on the PortalHome page. This is due to a bug that prevents users from
        // typing in input boxes if more than one Dialog is open on the page at a time
        [uiPauseReportAHireModal]: (state, { payload }) => ({
            ...state,
            pauseReportAHireModal: payload,
        }),
        [uiSetIsUpdateEmploymentStatusModalClosed]: (state, { payload }) => ({
            ...state,
            isUpdateEmploymentStatusModalClosed: payload,
        }),
    },
    {
        asyncError: null,
        loading: false,
        submitting: false,
        pauseReportAHireModal: null,
        isUpdateEmploymentStatusModalClosed: null,
    },
);

const toast = handleActions(
    {
        [showInfoToast]: (state, { payload: { content } }) =>
            state.concat([
                {
                    content,
                    type: TOAST_TYPE.INFO,
                },
            ]),
        [showWarningToast]: (state, { payload: { content } }) =>
            state.concat([
                {
                    content,
                    type: TOAST_TYPE.WARNING,
                },
            ]),
        [showErrorToast]: (state, { payload: { content } }) =>
            state.concat([
                {
                    content,
                    type: TOAST_TYPE.ERROR,
                },
            ]),
        [hideToast]: (state) => state.slice(0, state.length - 1),
    },
    [],
);

const positionAccess = handleActions(
    {
        [addPosition]: (state, { payload: { positionID } }) =>
            state.concat([positionID, -1, true, true]),
    },
    [],
);

const alertsCount = handleActions(
    {
        [setCommentCounts]: (state, { payload }) => ({ ...payload }),
        [decrementAlert]: (state, { payload }) => ({
            ...state,
            [payload]: state[payload] - 1 >= 0 ? state[payload] - 1 : 0,
        }),
        [incrementAlert]: (state, { payload }) => ({ ...state, [payload]: state[payload] + 1 }),
        [numberAlertChange]: (state, { payload: { numKey, numVal } }) => ({
            ...state,
            [numKey]: state[numKey] + numVal >= 0 ? state[numKey] + numVal : 0,
        }),
    },
    {},
);

export default combineReducers({
    actionStates: handleActions(
        {
            [setUserAction]: (state, { payload }) => {
                const newState = { ...state };
                delete newState[payload];
                return newState;
            },
        },
        {},
    ),

    announcement: (state = {}) => state,
    csrfToken: (state = "") => state,
    isAdmin: (state = false) => state,
    modals,

    positionAccess,
    accessiblePositions: (state = []) => state,
    permissionUser: (state = null) => state,
    hirePermissionRole: (state = null) => state,
    retainPermissionRole: (state = null) => state,
    hireAllAccess: (state = null) => state,
    retainAllAccess: (state = null) => state,
    adpAccessDisabled: (state = false) => state,
    accountType: (state = null) => state,
    rosterSyncEnabled: (state = false) => state,
    language: handleActions(
        {
            [setUserLanguage]: (state, { payload }) => payload,
        },
        null,
    ),

    toast,
    ui,
    user: (state = "") => state,
    hasAdp: (state = false) => state,
    hasDirectorySync: (state = false) => state,
    adpConsumerApplicationId: (state = "") => state,
    adpDataConnectorMarketplaceUrl: (state = "") => state,
    aws: (state = {}) => state,
    company: (state = {}) => state,
    queryString: (state = qs.parse(window.location.search)) => state,
    retoolEnvironment: (state = "") => state,
    alertsCount,
    demo: (state = { enabled: false }) => state,
    timezones: (state = []) => state,
});
